<template>
  <v-card class="to-do-item content-container">
    <v-card-title class="title">
      <v-layout align-start>
        <div class="title font-weight-bold">{{ toDoItem.title }}</div>
        <v-spacer />
        <v-icon
          style="cursor: pointer"
          class="error--text ml-2"
          size="18"
          @click="$emit('dismiss-to-do-item', toDoItem)"
        >
          clear
        </v-icon>
      </v-layout>
    </v-card-title>
    <!-- <v-alert :value="true"
             outline block :icon="$vuetify.breakpoint.smAndUp ? 'info' : '' "
             color="primary" class="text-xs-left mx-2">
      {{$t('questionnaire.notesAlert')}}
    </v-alert> -->
    <!-- <v-divider /> -->
    <v-card-text class="text-xs-left">
      {{ toDoItem.description }}
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        class="default-input primary text-capitalize"
        style="min-width: 200px"
        flat
        @click="takeAction(toDoItem)"
        :loading="itemLoading"
      >
        <v-icon class="mr-2" size="18">{{
          findActionButton(toDoItem).icon
        }}</v-icon>
        {{ findActionButton(toDoItem).text }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import API from '@/api';

export default {
  name: 'ToDoItemCard',
  props: {
    toDoItem: {
      type: Object,
      required: true,
    },
    itemLoading: {
      type: Boolean,
    },
  },
  data() {
    return {
      actionButtons: [
        {
          value: 'review_questionnaires',
          text: 'Review Questionnaires',
          // icon: "notes",
          action: 'open-questionnaires-table-dialog',
        },
        {
          value: 'review_notes',
          text: 'Review Client Notes',
          // icon: "sticky_note_2",
          action: 'open-questionnaire-comments-table-dialog',
        },
        {
          value: 'review_conversations',
          text: 'Review Conversations',
          // icon: "message",
          action: 'open-messages-table-dialog',
        },
        {
          value: 'review_documents',
          text: 'Review Uploads',
          // icon: "document",
          action: 'open-documents-table-dialog',
        },
      ],
    };
  },
  computed: {},
  methods: {
    isEmpty,
    moment,
    findActionButton(toDoItem) {
      return this.actionButtons.find(t => t.value === toDoItem.action_type);
    },
    takeAction(toDoItem) {
      const action = this.findActionButton(toDoItem).action;
      this.$emit(action, toDoItem);
    },
  },
  async created() {},
};
</script>

<style lang="css">
/* Unfortunately @apply cannot be setup in codesandbox,
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.to-do-item {
  width: 100%;
  /* max-width: 800px; */
}
</style>
